import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Component, Fragment } from "preact";
import { route } from "preact-router";


import CashoutService from "../../../services/cashout";
import Page from "../../../services/page-data-feed";
import PFeed from "../../../services/prematch-feed";
import LFeed from "../../../services/live-feed";
import User from "../../../services/user";

import { PaddedContainer } from "../mobile-templates/general";

import MenuTimeFilter from "../mobile-components/menu-time-filter";
import { Tournament } from "./live";
import { SearchComponent, TournamentCard, WrappedPrematchTournamentPage } from "./prematch";

import { WidgetEventsCarouselContent } from "../desktop-components/prematch-events-widget";
import SchedulesTimeFilter from "../utils/schedules-time-filter";
import FullSite from "./full-site";

import PrematchCarousel from "../desktop-components/prematch-carousel";

import * as D from "../desktop-templates/prematch-tournament.jsx";
import * as P from "../mobile-templates/sports";
import * as I from "../utils/icons";

import { TodayWidget } from '../mobile-components/today-widget.jsx';

import AwrabetMobilePageHome, {
	MobileLastMinute as AwrabetMobileLastMinute,
	MobileLiveEvents as AwrabetMobileLiveEvents,
	MobileMostPlayed as AwrabetMobileMostPlayed,
	MobileTopLeagues as AwrabetMobileTopLeagues,
	WithPrematch as AwrabetWithPrematch,
} from "../../awrabet/mobile-pages/home";

import { CasinoFavourites } from "../../../services/casino-feed";
import { useFeaturedGames } from "./casino/mobile";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { GameIcon } from "./casino";
import { useState } from "preact/hooks";
import { FakeSeparator } from "../mobile-templates/event";

export default class MobilePageHome extends AwrabetMobilePageHome {
	state = {
		openBetsCount: 0
	};

	componentDidMount() {
		if (User.isLogged()) {
			CashoutService.fetchOpenBets().then(bets => {
				this.setState({ openBetsCount: bets.length });
			}).catch(() => {
				this.setState({ openBetsCount: 0 });
			});
		}
	}

	render() {
		const sortedSportsList = PFeed.menu ? Object.values(PFeed.menu).sort((a, b) => a.order - b.order) : null;
		const { openBetsCount } = this.state;
		return <FullSite class="bg-slate-300 text-slate-950 dark:bg-transparent dark:text-inherit">
			<P.SportsHolder>
				<P.SportLikeButton onClick={e => window.location.href += '#betslip'}>
					<P.SportIconBox><I.TicketIcon class="h-6 -rotate-45" /></P.SportIconBox>
					<P.SportName>Check Bet</P.SportName>
				</P.SportLikeButton>
				{User.isLogged() && <P.SportLikeButton onClick={e => route('/cashout')}>
					<P.SportIconBox>
						<I.UserIcon class="h-full text-amber-500" />
						<span class="block absolute -top-1.5 -right-2 text-xs">{openBetsCount}</span>
					</P.SportIconBox>
					<P.SportName>My Bets</P.SportName>
				</P.SportLikeButton>}
				<P.SportLikeButton onClick={e => route('/live')}>
					<P.SportIconBox>
						<I.LiveIcon class="h-full" />
						{!LFeed.menu ? null : <LiveEventsBadge />}
					</P.SportIconBox>
					<P.SportName>Live</P.SportName>
				</P.SportLikeButton>
				{sortedSportsList && sortedSportsList
					.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
					.map(sport => {
						return <P.SportButton sport={sport} onClick={e => route('/prematch/' + sport.id.split('/')[2])} />
					})
				}
			</P.SportsHolder>
			<div class="aspect-1865/380 w-full">
				<PrematchCarousel />
			</div>
			{false && <PaddedContainer>
				<WidgetEventsCarouselContent />
			</PaddedContainer>}
			{false && <FeaturedCasinoGames />}
			<P.HeaderContainer>
				<MenuTimeFilter />
				<SearchComponent />
			</P.HeaderContainer>
			<MobileTopLeagues />
			<FakeSeparator />
			<WithPrematch><MobileTopWidget /></WithPrematch>
			<WithPrematch><MobileLiveEvents /></WithPrematch>
		</FullSite>
	}
}

export function LiveEventsBadge() {
	return <span class="block absolute -top-1.5 -right-2 text-xs">{Object.values(LFeed.menu).reduce((c, s) => c + s.count, 0)}</span>;
}

export function MobileTopWidget() {
	if (!PFeed.menu)
		return null;

	const [sportId, setSportId] = useState("/sport/1");

	const sortedSportsList = Object.values(PFeed.menu).sort((a, b) => a.order - b.order);

	return <div>
		<P.SportsHolder>
			{sortedSportsList
				.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
				.map(sport => ({...sport, count: countTodayEventsInSport(sport.id)}))
				.filter(s => s.count > 0)
				.slice(0, 10)
				.map(sport =>
					<P.SportButton
						active={sport.id == sportId}
						sport={sport}
						onClick={e => setSportId(sport.id)}
					/>
				)}
		</P.SportsHolder>
		<D.CardHeaderRow>
			<D.ThreeDots />
			<D.TournamentSportName>
				<Trans>Today</Trans>
				<span class="pl-2 text-custom-orange">{countTodayEventsInSport(sportId)}</span>
			</D.TournamentSportName>
		</D.CardHeaderRow>
		<TodayWidget sport={PFeed.menu[sportId]} />
	</div>
}

export function countTodayEventsInSport(sportId) {
	if (!PFeed.menu)
		return 0;

	const sport = PFeed.menu[sportId];
	if (!sport)
		return 0;

	const now = new Date();
	const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
	const msUntilMidnight = endOfDay - now.getTime();
	const hoursUntilMidnight = msUntilMidnight / (1000 * 60 * 60);

	if (hoursUntilMidnight > 8) {
		return sport["filter-count"]?.['24h'] || 0;
	}

	// TODO: sport["next-list"]?.["Xhour"] values are timestamps. This can absolutely be more precise

	if (hoursUntilMidnight > 3) {
		return Object.keys(sport["next-list"]?.["8hour"] || {}).length;
	}

	if (hoursUntilMidnight > 1) {
		return Object.keys(sport["next-list"]?.["3hour"] || {}).length;
	}

	return Object.keys(sport["next-list"]?.["1hour"] || {}).length;
}

export class MobileTopLeagues extends AwrabetMobileTopLeagues {
	render() {
		if (this.state.topLeagues.length == 0)
			return null;

		return <div>
			<D.CardHeaderRow>
				<D.ThreeDots />
				<D.TournamentSportName><Trans>Top Leagues</Trans></D.TournamentSportName>
			</D.CardHeaderRow>
			<div class="flex overflow-x-auto gap-2 p-2 bg-harif-900">
				{this.state.topLeagues.map(tournament => PFeed.getWithParents(tournament.id)).map(({ tournament, category }) => (
					<div
						class={"flex shrink-0 items-center text-white gap-2 rounded-md border border-harif-800 px-2 py-1 text-sm " + (this.isCurrent(tournament) ? 'bg-harif-800' : 'bg-harif-900')}
						onClick={e => this.setTournament(tournament)}
					>
						<P.TournamentIcon tournament={tournament} class={"h-5 w-5 league-" + category.name.toLowerCase().replace(/ /g, '') + tournament.name.toLowerCase().replace(/ /g, '')} />
						<span class="inline-block min-w-0 flex-1 truncate">{tournament.name}</span>
					</div>
				))}
			</div>
			{this.state.currentTournamentId && <WrappedPrematchTournamentPage key={this.state.currentTournamentId} tournamentId={this.state.currentTournamentId}>
				{({ tournament }) => <Fragment>
					<TournamentCard tournamentCard={tournament} minEvents={this.state.isShowMore ? Infinity : 5} />
					{this.state.isShowMore ? null : <div class="p-4 text-center">
						<button
							onClick={e => this.setState({isShowMore: true})}
							class="bg-custom-orange text-black px-6 py-2 rounded uppercase"
						>
							<Trans>Show More</Trans>
						</button>
					</div>}
				</Fragment>}
			</WrappedPrematchTournamentPage>}
		</div>
	}
}


export class WithPrematch extends AwrabetWithPrematch {
	render({ children }) {
		if (!PFeed.menu)
			return;
		return children;
	}
}

export class MobileLastMinute extends AwrabetMobileLastMinute {
	render() {
		if (!this.state.tournament) return null;
		return <div>
			<D.CardHeaderRow>
				<D.ThreeDots />
				<D.TournamentSportName><Trans>Last Minute</Trans></D.TournamentSportName>
			</D.CardHeaderRow>
			<TournamentCard tournamentCard={this.state.tournament} />
		</div>
	}
}
export class MobileMostPlayed extends AwrabetMobileMostPlayed {
	render() {
		if (!this.state.tournament) return null;
		return <div>
			<D.CardHeaderRow>
				<D.ThreeDots />
				<D.TournamentSportName><Trans>Top Matches</Trans></D.TournamentSportName>
			</D.CardHeaderRow>
			<TournamentCard tournamentCard={this.state.tournament} />
		</div>
	}
}
export class MobileLiveEvents extends AwrabetMobileLiveEvents {
	render() {
		return <div>
			<D.CardHeaderRow>
				<D.ThreeDots />
				<D.TournamentSportName><Trans>Live</Trans></D.TournamentSportName>
			</D.CardHeaderRow>
			{this.getCurrentSport() && this.getCategories().map(tournament =>
				<Tournament key={tournament.id} tournament={tournament} />
			)}
		</div>
	}
}

class CasinoPreviewTabs extends Component {
	state = { tab: 'popular' };

	getCounts() {
		return {
			recents: CasinoFavourites.getPlayed()?.length || 0,
			popular: CasinoFavourites.getFavourites()?.length || 0
		};
	}

	render() {
		const { recents, popular } = this.getCounts();
		const isRec = this.state.tab === 'recents';
		const isPop = this.state.tab === 'popular';

		return <div class="px-3 pt-2 pb-3">
			<div class="flex gap-2 items-end">
				<button
					class={`relative rounded-md px-3 py-2 text-base text-white ${isRec ? 'bg-custom-orange' : 'bg-harif-900'}`}
					onClick={() => this.setState({ tab: 'recents' })}
				>
					<Trans>Recents</Trans>
					<span class={`ml-2 inline-flex min-w-5 h-5 items-center justify-center rounded bg-harif-800 px-1 text-xs ${isRec ? 'text-white' : 'text-white/90'}`}>{recents}</span>
				</button>

				<button
					class={`relative rounded-md px-3 py-2 text-base text-white ${isPop ? 'bg-custom-orange' : 'bg-harif-900'}`}
					onClick={() => this.setState({ tab: 'popular' })}
				>
					<Trans>Most Popular</Trans>
					<span class={`ml-2 inline-flex min-w-5 h-5 items-center justify-center rounded bg-harif-800 px-1 text-xs ${isPop ? 'text-white' : 'text-white/90'}`}>{popular}</span>
				</button>
			</div>

			<CasinoGamesStrip gamesList={(isRec ? CasinoFavourites.getPlayed() : CasinoFavourites.getFavourites()) || []} />
		</div>;
	}
}

function FeaturedCasinoGames() {
	const games = useFeaturedGames();
	if (!games || !games.length)
		return null;
	return <div>
		<CasinoGamesStrip gamesList={games} />
	</div>
}

function CasinoGamesStrip({ gamesList }) {
	if (!gamesList || !gamesList.length)
		return null;

	const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: 'start' }, [Autoplay()])

	return <div class="embla" ref={emblaRef}>
		<div class="embla__container flex h-20 will-change-transform">
			{gamesList.slice(0, 20).map(game => <FeaturedGameIcon game={game} />)}
		</div>
	</div>;
}

export class FeaturedGameIcon extends GameIcon {
	render({ game }) {
		return (
			<a key={[game.provider, game.brand, game.id].join("")} class="flex h-full aspect-square flex-col pl-1 pb-1" href="javascript:void(0);" onClick={e => this.openGame(game)}>
				<img class="w-full rounded-lg grow shrink object-cover object-center bg-harif-800 h-0 min-h-12.5" src={this.getImgUrl(game.logo)} loading="lazy" />
			</a>
		);
	}
}